import(/* webpackMode: "eager", webpackExports: ["AvatarWidget"] */ "/app/components/AvatarWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/components/Footer/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/components/Header/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["SentryInit"] */ "/app/components/SentryInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/comps/AdminBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/comps/ScrollToTop.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/slick-carousel@1.8.1_jquery@4.0.0/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/slick-carousel@1.8.1_jquery@4.0.0/node_modules/slick-carousel/slick/slick-theme.css");
